export enum LocalStorageKey {
  userLogged = 'USER_LOGGED',
  oauthInfo = 'OAUTH_INFO',
  clientSelected = 'CLIENT_SELECTED',
  qnSelected = 'QN_SELECTED',
  languageSelected = 'LANGUAGE_SELECTED'
}
